import { FC } from 'react'

import { CustomerLogo, GreyGrey20, Center } from '@sequencehq/core-components'
import { getLogoSrc } from 'Customer/index'

export const CustomerLogoCircle: FC<{
  customer: { domain?: string }
  size?: number
  fallbackSize?: number
}> = ({ customer, size = 32, fallbackSize }) => (
  <Center
    borderRadius="50%"
    overflow="visible"
    boxSize={`${size}px`}
    background={GreyGrey20}
  >
    <CustomerLogo
      src={getLogoSrc({ domain: customer.domain ?? '' })}
      size={size}
      fallbackSize={fallbackSize}
    />
  </Center>
)
